export const resultEstoque = [
  {
    category: "resultados",
    key: "inventarioEstoque",
    name: "Inventario de estoque",
  },
];
